// ispLinkSummary — "¿cuántos enlaces están arriba?" en UN solo lugar.
//
// ── EL BUG QUE CIERRA (20-sep-2026) ─────────────────────────────────────────
// Esta cuenta vivía duplicada LITERAL en tres archivos (IspLinksWidget,
// CompaniesPage y el PortalConnectivitiesPage del cliente), y las tres decían:
//
//     const up = links.filter(l => l.status !== 'critical').length;
//
// "Distinto de critical" mete en la bolsa de ARRIBA a healthy, warning, unknown,
// maintenance y paused. Durante el corte de luz de la Mikve eso producía la
// frase "1/2 enlaces UP — sitio online por redundancia" mientras el sitio estaba
// muerto: el enlace que no podíamos confirmar se contaba como si funcionara.
//
// Es peor que un punto verde de más. Es una AFIRMACIÓN sobre el sitio, y salía
// también en el portal del cliente.
//
// ── LAS TRES CATEGORÍAS ─────────────────────────────────────────────────────
// El error de fondo era binario: arriba o abajo. Pero hay un tercer estado real
// y es el importante: NO SE PUEDE CONFIRMAR. Un enlace en 'unknown' (ver
// _alerting/linkTrust.js) o que nosotros mismos pusimos en mantenimiento no es
// evidencia de nada, y sumarlo a "arriba" es exactamente el salto que queremos
// dejar de dar.
const ARRIBA = new Set(['healthy', 'warning']);
const ABAJO = new Set(['critical']);
// unknown / maintenance / paused → sin confirmar.

/**
 * @param {Array<{status:string}>} links
 * @returns {{total:number, up:number, down:number, unconfirmed:number,
 *            color:string, i18nKey:string, i18nParams:object}}
 */
export function summarizeLinks(links) {
  const list = links || [];
  const total = list.length;
  const up = list.filter(l => ARRIBA.has(l.status)).length;
  const down = list.filter(l => ABAJO.has(l.status)).length;
  const unconfirmed = total - up - down;

  let color, i18nKey, i18nParams;
  if (total === 0) {
    color = '#9ca3af'; i18nKey = 'companies.linksNone'; i18nParams = {};
  } else if (down === total) {
    color = '#ef4444'; i18nKey = 'companies.linksAllDown'; i18nParams = { total };
  } else if (unconfirmed === total) {
    // Ninguno confirmado: gris, no verde. No sabemos.
    color = '#9ca3af'; i18nKey = 'companies.linksAllUnconfirmed'; i18nParams = { total };
  } else if (unconfirmed > 0) {
    // Lo importante es que el "sin confirmar" se NOMBRE, no que desaparezca.
    color = '#f59e0b'; i18nKey = 'companies.linksUnconfirmed'; i18nParams = { up, total, unconfirmed };
  } else if (down > 0) {
    color = '#f59e0b'; i18nKey = 'companies.linksDegraded'; i18nParams = { up, total };
  } else if (total > 1) {
    color = '#22c55e'; i18nKey = 'companies.linksAllUp'; i18nParams = { total };
  } else {
    color = '#22c55e'; i18nKey = 'companies.linkSingleUp'; i18nParams = {};
  }
  return { total, up, down, unconfirmed, color, i18nKey, i18nParams };
}
